<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body fs-12">
        <div class="live-preview">
          <form
            class="row g-3 needs-validation"
            novalidate
            (ngSubmit)="submitForm()"
            [formGroup]="filterForm"
          >
            <div class="col-md-5">
              <div class="input-group">
                <label class="input-group-text">Proceso </label>
                <select
                  class="form-control"
                  formControlName="proceso"
                  (change)="onProcesoChange($event)"
                >
                  <option [value]="0">Seleccione</option>
                  <option
                    *ngFor="let proceso of procesos"
                    [value]="proceso.opcionId"
                  >
                    {{ proceso.texto }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-5">
              <div class="input-group">
                <label class="input-group-text">SubProceso </label>
                <select
                  class="form-control"
                  formControlName="subProceso"
                  (change)="onSubProcesoChange($event)"
                >
                  <option [value]="0">Seleccione</option>
                  <option
                    *ngFor="let subProceso of subProcesos"
                    [value]="subProceso.opcionId"
                  >
                    {{ subProceso.texto }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="input-group">
                <label class="input-group-text">Cliente </label>
                <select
                  class="form-control"
                  formControlName="cliente"
                  (change)="onClienteChange($event)"
                >
                  <option [value]="0">Seleccione</option>
                  <option
                    *ngFor="let cliente of clientes"
                    [value]="cliente.opcionId"
                  >
                    {{ cliente.texto }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="input-group">
                <label class="input-group-text">Proyecto </label>
                <select
                  class="form-control"
                  formControlName="proyecto"
                  (change)="onProyectoChange($event)"
                >
                  <option [value]="0">Seleccione</option>
                  <option
                    *ngFor="let proyecto of proyectos"
                    [value]="proyecto.opcionId"
                  >
                    {{ proyecto.texto }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="input-group">
                <label class="input-group-text">Zona</label>
                <select
                  class="form-control"
                  formControlName="sede"
                  (change)="onSedeChange($event)"
                >
                  <option [value]="0">Seleccione</option>
                  <option *ngFor="let sede of sedes" [value]="sede.opcionId">
                    {{ sede.texto }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <!-- <div class="btn-group" role="group" ngbDropdown>
                <button id="btnGroupDrop1" type="button" class="btn btn-info dropdown-toggle arrow-none"
                  data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle> Opciones
                  <i class="ri-arrow-down-s-line"></i>
                </button>
                <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1" ngbDropdownMenu>
                  <li><a class="dropdown-item" href="javascript:void(0);" (click)="submitForm()">Buscar</a>
                  </li>
                  @if (authService.canViewOption('VER_TODOS_PLANES_TRABAJO') ||
                  authService.canViewOption('VER_TODOS_PLANES_CAPACITACION')) {
                  <li><a class="dropdown-item" href="javascript:void(0);" (click)="filtrarTodos()">Todos</a></li>
                  }
                  @if (authService.canViewOption('EXPORTAR_PLAN_TRABAJO') ||
                  authService.canViewOption('EXPORTAR_PLAN_CAPACITACION')) {
                  <li><a class="dropdown-item" href="javascript:void(0);" (click)="exportar()">Exportar</a></li>
                  }
                </ul>
              </div> -->

              <button class="btn btn-primary mx-1" type="submit">Buscar</button>

              @if (
                authService.canViewOption("VER_TODOS_PLANES_TRABAJO") ||
                authService.canViewOption("VER_TODOS_PLANES_CAPACITACION")
              ) {
                <button
                  class="btn btn-secondary mx-1"
                  type="button"
                  (click)="filtrarTodos()"
                >
                  Todos
                </button>
              }

              @if (
                authService.canViewOption("EXPORTAR_PLAN_TRABAJO") ||
                authService.canViewOption("EXPORTAR_PLAN_CAPACITACION")
              ) {
                <button
                  class="btn btn-success mx-1"
                  type="button"
                  (click)="exportar()"
                >
                  Exportar
                </button>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
